import { FormControlLabel, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomRadioButton, CustomStyleRadio } from "./Styles";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Radio Button with dynamic content
 * @param String id: Identifier for the Radio Button (required)
 * @param String trans: Text for the label (optional)
 * @param String name: Name for the Radio Button (optional)
 * @param String value: Defines value for Radio Button  (optional)
 * @param Boolean checked: Is checked (required)
 * @param Boolean disabled: Enable/disable Radio Button (optional)
 * @param Event onChange: onChange trigger in the Radio Button (required)
 * @param {string} [props.color] - Custom color for the Radio Button icon (optional).
 * @param {string} [labelClassName] - Custom class for the label text (optional)
 * @returns {JSX.Element}
 */

const CustomRadio = ({ id, trans, name, value, checked, onChange, disabled, color, labelClassName }) => {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <CustomRadioButton
            name={name}
            id={id}
            disabled={disabled}
            onChange={onChange}
            value={value}
            checked={checked}
            $color={color}
          />
        }
        label={t(trans)}
        sx={CustomStyleRadio(false)}
        classes={{
          label: labelClassName,
        }}
      />
    </FormGroup>
  );
};



export default CustomRadio;
